import React, { useEffect } from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { useLayout } from '../../context';
export const LayoutRoute = ({ isFullPage = false, ...props }) => {
    const { setIsFullPage } = useLayout();
    const match = useRouteMatch(props);
    useEffect(() => {
        if (match && match.isExact) {
            setIsFullPage(isFullPage);
        }
        return () => setIsFullPage(false);
    }, [setIsFullPage, isFullPage, match]);
    return React.createElement(Route, { ...props });
};
